import React, { useState } from 'react';

export const LoginScreen: React.FC<{ onLogin: (pin: string) => void }> = ({ onLogin }) => {
  const [input, setInput] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input.trim()) {
      onLogin(input.trim());
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-paper/50">
      <div className="panel max-w-sm w-full p-8 text-center flex flex-col gap-6 shadow-cardHover">
        <div className="w-16 h-16 rounded-full bg-sage/10 flex items-center justify-center border border-sage/20 mx-auto">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" className="text-sage">
             <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Z"/>
             <path d="M12 6a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm0 10a4 4 0 1 1 4-4 4 4 0 0 1-4 4Z"/>
          </svg>
        </div>
        
        <div>
          <h1 className="plant-name text-2xl font-bold text-cream">Privater Bereich</h1>
          <p className="text-creamDim text-sm mt-2">
            Diese App ist privat. Bitte gib die PIN ein, um auf die Pflanzenkarten zuzugreifen.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4 mt-2">
          <input
            type="password"
            placeholder="PIN Code"
            className="input text-center text-xl tracking-widest bg-white"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            autoFocus
          />
          <button type="submit" className="btn-primary w-full justify-center py-3 text-base">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="inline">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            Entsperren
          </button>
        </form>

        <p className="text-creamDim/40 text-[10px] font-mono mt-4 uppercase tracking-wider">
          Geschützter Bereich • Nur für den privaten Gebrauch
        </p>
      </div>
    </div>
  );
};
